import formatPhone from "@shared/filters/phone.js";
import * as _ from "lodash";

var salesRepItemTemplateCB = function (item) {
  let s = `<div editable=${item.editable}
           class='tagify__dropdown__item ${item.class ? item.class : ""}'
           tabindex="0"
           role="option">
           <div class='default-body--bold padding-bottom--smallest'>
             ${item.name || item.display_name}`;
  if (item.distributor) {
    s += ` (${item.distributor.name})`;
  } else if (item.distributors) {
    s += ` (${item.distributors.map(d => d.name).join(", ")})`;
  }
  s += `</div>`;
  if (item.contact_email) {
    s += `
                 <div class='default-body--regular padding-bottom--smallest'>
                   ${item.contact_email}
                 </div>
               `;
  }
  if (item.contact_phone) {
    s += `
                 <div class='default-body--regular'>
                   ${formatPhone(item.contact_phone)}
                 </div>
               `;
  }
  s += `</div>`;
  return s;
};
var prepare = function (scope) {
  scope.extraParams = {};
  scope.widget = {
    descriptionField: scope.descriptionField,
    inputModel: [],
    addToListFromAutocompleteOnly: scope.addToListFromAutocompleteOnly,
  };
  switch (scope.objectType) {
    case "product_line":
      scope.widget.id = "product_lines_autocomplete";
      scope.widget.placeholder = "Search Product Lines...";
      scope.widget.path = "product_lines";
      scope.widget.descriptionField = scope.descriptionField || "manufacturer.name";
      break;
    case "product":
      scope.widget.id = "products_autocomplete";
      scope.widget.placeholder = "Search Products...";
      scope.widget.path = "products";
    case "retailer":
      scope.widget.id = "retailers_autocomplete";
      scope.widget.placeholder = "Search Retailers...";
      scope.widget.path = "retailers";
      scope.extraParams.listType = "retailers";
      break;
    case "manufacturer":
      scope.widget.id = "manufacturers_autocomplete";
      scope.widget.placeholder = "Search Manufacturers...";
      scope.widget.path = "manufacturers";
      break;
    case "brand_family":
      scope.widget.id = "brand_families_autocomplete";
      scope.widget.placeholder = "Search Brand Families...";
      scope.widget.path = "brand_families";
      break;
    case "distributor":
      scope.widget.id = "distributors_autocomplete";
      scope.widget.placeholder = "Search Distributors...";
      scope.widget.path = "distributors";
      scope.extraParams.listType = "distributors";
      break;
    case "distribution_area":
      scope.widget.id = "distribution_areas_autocomplete";
      scope.widget.placeholder = "Search Distribution Areas...";
      scope.widget.path = "distribution_areas";
      break;
    case "category":
      scope.widget.id = "categories_autocomplete";
      scope.widget.placeholder = "Search Categories";
      scope.widget.path = "categories";
      break;
    case "subcategory":
      scope.widget.id = "subcategories_autocomplete";
      scope.widget.placeholder = "Search Subcategories...";
      scope.widget.path = "subcategories";
      break;
    case "collection":
      scope.widget.id = "collections_autocomplete";
      scope.widget.placeholder = "Search Collections By Name...";
      scope.widget.path = "collections";
      break;
    case "segment":
      scope.widget.id = "segments_autocomplete";
      scope.widget.placeholder = "Search Segments...";
      scope.widget.path = "collection_segments";
      scope.widget.descriptionField = scope.descriptionField || "zip";
      break;
    case "user":
      scope.widget.id = "users_autocomplete";
      scope.widget.placeholder = "Search Users by Name or Email...";
      scope.widget.path = "users";
      scope.widget.descriptionField = scope.descriptionField || "email";
      scope.titleField = "first_name,last_name";
      if (scope.listMode) {
        scope.titleField = "email";
      }
      scope.nameField = "email";
      break;
    case "sales_rep":
      scope.widget.id = "sales_reps_autocomplete";
      scope.widget.placeholder = "Search Sales Reps...";
      scope.widget.path = "sales_reps";
      scope.widget.descriptionField = scope.descriptionField || "contact_email";
      scope.widget.dropdownItemTemplateCB = salesRepItemTemplateCB;
      break;
    case "warehouse":
      scope.widget.id = "warehouses_autocomplete";
      scope.widget.placeholder = "Search Warehouses...";
      scope.widget.path = "warehouses";
      break;
    case "wine_appellation":
      scope.widget.id = "wine_appellation_autocomplete";
      scope.widget.placeholder = "Search Wine Appellations...";
      scope.widget.path = "wine_appellations";
      break;
    case "wine_region":
      scope.widget.id = "wine_region_autocomplete";
      scope.widget.placeholder = "Search Wine Regions...";
      scope.widget.path = "wine_regions";
      break;
    case "wine_varietal":
      scope.widget.id = "wine_varietal_autocomplete";
      scope.widget.placeholder = "Search Wine Varietals...";
      scope.widget.path = "wine_varietals";
      break;
    case "city":
      scope.widget.id = "cities_autocomplete";
      scope.widget.placeholder = "Add a city...";
      break;
    case "zipcode":
      scope.widget.id = "zipcodes_autocomplete";
      scope.widget.placeholder = "Add a zipcode...";
      break;
    case "market":
      scope.widget.id = "markets_autocomplete";
      scope.widget.placeholder = "Add a market...";
      scope.widget.path = "markets";
      break;
  }
  scope.widget.titleField = scope.titleField || "name";
  scope.nameField = scope.nameField || "name";
  scope.searchURL = scope.searchUrlInput || `/api/${window.C.APP_NAME}/` + scope.widget.path;
  scope.keyName = scope.objectType + "_id";
  scope.nameName = scope.objectType + "_name";
  scope.widget.initialValue = scope.initialValue;
  if (scope.selectModel && !scope.initialValue && !scope.listMode) {
    scope.setInitialValue();
  }
  return scope;
};

var searchAPI = function (scope, input) {
  var params = {
    search: input,
    show_all: true,
    all_retailers: true,
  };
  if (scope.objectType == "sales_rep" && ["onboarding", "retailer"].includes(window.C.APP_NAME)) {
    params.search_query = input;
  }
  if (scope.listMode && input == null) {
    delete params.search;
  }
  if (scope.apiParams) {
    let apiParamsValue = scope.apiParams;

    if (typeof scope.apiParams == "function") {
      apiParamsValue = scope.apiParams();
    }

    params = _.merge(params, apiParamsValue);
  }
  return window.$http({
    method: "GET",
    url: scope.searchURL,
    params: params,
  });
};

export default {
  prepare: prepare,
  searchAPI: searchAPI,
};
